import { reportError } from '@lib/report-error';

export const ExpectedLicense = '8045841';

const configuredLicense = () => window.__lc?.license;

const hasDrifted = (license) => Boolean(license) && String(license) !== ExpectedLicense;

const driftMessage = (license) =>
  `Chat widget: Commversion configured LiveChat account ${String(license)}, expected ${ExpectedLicense}.`;

export const reportAccountDrift = () => {
  try {
    const license = configuredLicense();

    if (hasDrifted(license)) {
      reportError(driftMessage(license));
    }
  } catch {}
};
